import React, { useEffect, useMemo, useRef, useState } from 'react'
import clsx from 'clsx'
import { EventType, FieldTypes } from '../../utils/constants'
import useApartmentsApi from '../../hooks/apartments/useApartmentsApi'
import Form from '../common/Form'
import useEventsApi from '../../hooks/events/useEventsApi'
import useUserEventsApi from '../../hooks/userEvents/useUserEventsApi'
import useBuildingsApi from '../../hooks/buildings/useBuildingsApi'
import useBlacklistedStore from '../../stores/BlacklistedStore'
import useUserInvitationsApi from '../../hooks/userInvitations/useUserInvitationsApi'
import { useIsSecurityUser } from '../../hooks/useIsSecurityUser'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import ListHeader from '../common/ListHeader'
import useStyles from '../common/FormFields/FormFieldsStyle'
import { debounce } from 'lodash'
import useConstructionStore from '../../stores/ConstructionStore'

export default function ManualEventForm({
  isModal,
  building,
  handleCancel,
  afterSubmit,
}) {
  const classes = useStyles()

  const [values, setValues] = useState({})
  const [selectedBuilding, setSelectedBuilding] = useState(building || null)
  const [_, { createManualEvent }] = useEventsApi()
  const history = useHistory()

  const [companions, setCompanions] = useState([
    { ci: '', firstName: '', lastName: '' },
    { ci: '', firstName: '', lastName: '' },
    { ci: '', firstName: '', lastName: '' },
  ])
  const [invitationType, setInvitationType] = useState(0)
  const [{ userInvitationState }, methods] = useUserInvitationsApi()
  const [{ eventsState }, userEventMethods] = useUserEventsApi()
  const [isService, setIsService] = useState(false)
  const [{ buildingsState }, { getBuildings }] = useBuildingsApi()
  const blackListedState = useBlacklistedStore((state) => state)
  const constructionsState = useConstructionStore((state) => state)
  const getBlacklisted = blackListedState.fetchBlacklisted
  const blacklisted = blackListedState?.blacklisted || []
  const constructions = constructionsState?.constructions || []
  const getConstructions = constructionsState.fetchConstructions

  const [{ getApartmentsFromBuildingState }, { getApartmentsFromBuilding }] =
    useApartmentsApi()
  const isSecurity = useIsSecurityUser()

  useEffect(() => {
    const fetchApartmentsFromBuilding = async () => {
      getApartmentsFromBuilding(selectedBuilding?.id)
    }
    const fetchData = async (params) => {
      fetchApartmentsFromBuilding()
      methods.getSettings()
      userEventMethods.getEvents({ buildingId: selectedBuilding?.id })
      getBlacklisted({ buildingId: selectedBuilding?.id })
      getConstructions({ buildingId: selectedBuilding?.id })
    }
    if (selectedBuilding) {
      fetchData()
    }
  }, [selectedBuilding])

  useEffect(() => {
    if (isSecurity) {
      setIsService(true)
    }
  }, [isSecurity])

  useEffect(() => {
    const fetchData = async () => {
      getBuildings()
    }
    fetchData()
  }, [])

  useEffect(() => {
    let event = values.event
    let apartments = values.apartments

    if (userInvitationState?.getResponse?.lastManualEvent) {
      if (
        userInvitationState?.getResponse?.lastManualEvent.payload[
          'Acompañantes'
        ]
      ) {
        setCompanions(
          userInvitationState?.getResponse?.lastManualEvent.payload[
            'Acompañantes'
          ]
        )
      } else {
        setCompanions([
          { ci: '', firstName: '', lastName: '' },
          { ci: '', firstName: '', lastName: '' },
          { ci: '', firstName: '', lastName: '' },
        ])
      }
      if (userInvitationState?.getResponse?.lastManualEvent.payload['Evento']) {
        event = eventsState?.events.find(
          (event) =>
            (event.name =
              userInvitationState?.getResponse?.lastManualEvent.payload[
                'Evento'
              ])
        )
      } else {
        event = null
      }
      if (userInvitationState?.getResponse?.lastManualEvent.apartments) {
        apartments =
          userInvitationState?.getResponse?.lastManualEvent.apartments
      } else {
        apartments = []
      }
      if (
        userInvitationState?.getResponse?.lastManualEvent.type ===
        EventType.MANUAL_ENTRY
      ) {
        setInvitationType(1)
      } else {
        setInvitationType(0)
      }
    } else {
      setInvitationType(0)
      event = null
      apartments = []
      setCompanions([
        { ci: '', firstName: '', lastName: '' },
        { ci: '', firstName: '', lastName: '' },
        { ci: '', firstName: '', lastName: '' },
      ])
    }

    setValues({
      ...values,
      plate: userInvitationState?.getResponse?.lastManualEvent
        ? userInvitationState?.getResponse?.lastManualEvent.payload['Matricula']
        : '',
      event,
      apartments,
      selfie: userInvitationState?.getResponse?.selfie,
    })
  }, [userInvitationState?.getResponse])

  useEffect(() => {
    let updatedValues = {}
    if (values.invitation?.selfie) {
      updatedValues = {
        ...updatedValues,
        selfie: values.invitation.selfie,
      }
    }
    if (values.invitation?.serviceType) {
      setIsService(true)
      updatedValues = {
        ...updatedValues,
        vertical: values.invitation.serviceType,
        company: values.invitation.company,
      }
    } else {
      setIsService(false)
      updatedValues = {
        ...updatedValues,
        vertical: null,
        company: null,
      }
    }
    if (values.invitation?.building) {
      updatedValues = {
        ...updatedValues,
        firstName: values.invitation.firstName,
        lastName: values.invitation.lastName,
        ci: values.invitation.ci,
      }
    }
    if (!values.invitation) {
      setInvitationType(0)
      setCompanions([
        { ci: '', firstName: '', lastName: '' },
        { ci: '', firstName: '', lastName: '' },
        { ci: '', firstName: '', lastName: '' },
      ])
      updatedValues = {
        firstName: '',
        lastName: '',
        ci: '',
        description: '',
        plate: '',
        event: null,
        apartments: [],
        selfie: null,
      }
    }
    setValues((prevValues) => ({
      ...prevValues,
      ...updatedValues,
    }))
  }, [values.invitation])

  const debouncedHandleInputChange = debounce(
    (event, newInputValue, reason) => {
      if (reason === 'input') {
        if (values.ci !== newInputValue.trim() && newInputValue.length >= 3) {
          methods.getInvitations({
            buildingId: building?.id,
            search: newInputValue,
          })
        }
      }
    },
    500
  )

  const debouncedHandleInputChangeCampanion = debounce((newInputValue) => {
    if (!newInputValue) {
      return
    }
    const parsedValue = newInputValue.trim()
    if (values.ci !== parsedValue && parsedValue?.length >= 3) {
      methods.getInvitations({
        buildingId: building?.id,
        search: parsedValue,
      })
    }
    // }
  }, 1000)

  const createManualEventFromCallback = (invitation) => {
    let serviceType
    if (values.vertical) {
      serviceType = userInvitationState?.serviceTypes?.find(
        (type) => type.id === values.vertical || type.name === values.vertical
      ).name
    }
    createManualEvent({
      payload: {
        name: values.invitation
          ? `${values.invitation.firstName || ''} ${
              values.invitation.lastName || ''
            }`
          : `${values.firstName || ''} ${values.lastName || ''}`,
        ci: values.invitation ? values.invitation.ci : values?.ci,
        description: values?.description,
        event: values.event?.name,
        company: values.company,
        vertical: serviceType,
        plate: values.plate,
        companions,
      },
      invitation: invitation,
      selfie: values.selfie,
      selectedApartments: values.apartments,
      type: invitationType === 0 ? 'MANUAL_ENTRY' : 'MANUAL_EXIT',
    })
  }

  const handleSubmit = async (event) => {
    let serviceType
    if (values.vertical) {
      serviceType = userInvitationState?.serviceTypes?.find(
        (type) => type.id === values.vertical || type.name === values.vertical
      ).name
    }
    if (!values.invitation) {
      await methods.createUserInvitation(
        {
          firstName: values.firstName,
          lastName: values.lastName,
          ci: values.ci,
          selfie: values.selfie,
          buildingId: selectedBuilding?.id,
          enabled: true,
          serviceType,
          company: values.company,
          companions,
          apartments: values.apartments.map((apartment) => apartment.id),
          isGeneralService: values.apartments[0].isGeneralService ?? false,
        },
        createManualEventFromCallback
      )
    } else {
      await createManualEvent({
        payload: {
          name: values.invitation
            ? `${values.invitation.firstName || ''} ${
                values.invitation.lastName || ''
              }`
            : `${values.firstName || ''} ${values.lastName || ''}`,
          ci: values.invitation ? values.invitation.ci : values?.ci,
          description: values?.description,
          event: values.event?.name,
          company: values.company,
          vertical: serviceType,
          plate: values.plate,
          companions,
        },
        invitation: values.invitation,
        selfie: values.selfie,
        selectedApartments: values.apartments,
        type: invitationType === 0 ? 'MANUAL_ENTRY' : 'MANUAL_EXIT',
      })
    }
    if (afterSubmit) {
      afterSubmit()
    }
    if (!isModal) {
      setTimeout(() => {
        history.push(building ? `/eventosEdificio` : `/eventos`)
      }, 1000)
    }
  }

  const handleSelectFile = (event) => {
    event.preventDefault()
    var files = event.target.files,
      f = files[0]
    var reader = new FileReader()
    reader.onload = (e) => {
      var data = e.target.result
      setValues({ ...values, selfie: data })
    }
    reader.readAsDataURL(f)
  }

  const handleUpdateCompanions = (companion, i) => {
    console.log('companion', companion, i)
    const currentCompanions = companions.slice()
    currentCompanions[i] = companion
    setCompanions(currentCompanions)
  }

  const handleRemoveCompanion = (i) => {
    const currentCompanions = companions.slice()
    currentCompanions.splice(i, 1)
    setCompanions(currentCompanions)
  }

  const handleAddCompanion = () => {
    const currentCompanions = companions.slice()
    currentCompanions.push({ ci: '', firstName: '', lastName: '' })
    setCompanions(currentCompanions)
  }

  const getConstructionNameFromCI = (ci) => {
    let found = []
    constructions.forEach((construction) => {
      construction.constructionMembers.forEach((member) => {
        if (member.ci === ci) {
          found.push(construction)
        }
      })
    })
    return found.map((construction) => construction.name).join(', ')
  }

  const invitationAutocompleteData = useMemo(() => {
    const uniqueInvitations = []
    const seenCIs = new Set()
    userInvitationState?.invitations?.data.forEach((invitation) => {
      if (!seenCIs.has(invitation.ci)) {
        uniqueInvitations.push(invitation)
        if (invitation.ci) {
          seenCIs.add(invitation.ci)
        }
      }
    })
    blacklisted
      .filter((blackListed) => !blackListed.invitation && blackListed.ci)
      .forEach((blackListed) => {
        if (!seenCIs.has(blackListed.ci)) {
          uniqueInvitations.push({
            ci: blackListed.ci,
            firstName: blackListed.name.split(' ')[0],
            lastName: blackListed.name.split(' ')[1],
            blackListed: true,
          })
          seenCIs.add(blackListed.ci)
        }
      })
    return uniqueInvitations
  }, [userInvitationState, blacklisted])

  const isCiBlacklisted = useMemo(() => {
    return blacklisted.some((item) => {
      return item.ci == values.ci
    })
  }, [values.ci, blacklisted])

  const inputRef = useRef()

  if (isSecurity && !building) {
    return <></>
  }

  return (
    <div className={classes.paper}>
      <ListHeader bigTitle="Control de acceso manual" canCreate={false} />
      <Form
        values={values}
        setValues={setValues}
        extraWidth
        fields={[
          ...(!building
            ? [
                {
                  type: FieldTypes.Autocomplete,
                  label: 'Cliente',
                  hint: 'Seleccione un cliente',
                  key: 'building',
                  options: buildingsState.buildings ?? [],
                  multiple: false,
                  freeSolo: false,
                  withMargin: true,
                  onChange: (value) => {
                    setSelectedBuilding(value)
                    setValues({ ...values, building: value })
                  },
                  errorMessage: 'El cliente es requerido',
                },
              ]
            : []),
          {
            type: FieldTypes.Autocomplete,
            label:
              'Búsqueda de visitantes / servicios por documento de identidad',
            hint: 'Seleccionar documento de identidad',
            key: 'invitation',
            options: invitationAutocompleteData,
            multiple: false,
            freeSolo: false,
            withMargin: true,
            onChange: (value) => {
              if (value) {
                if (value.blackListed) return
                methods.getUserInvitation(value?.id)
              }
              setValues({ ...values, invitation: value })
            },
            onInputChange: debouncedHandleInputChange,
            loading: userInvitationState.isLoading,
            disabled: !selectedBuilding,
            getOptionLabel: (option) => {
              const blackListed = !!option.blackListed

              if (option.firstName && option.ci) {
                return `${option.firstName} ${option.lastName} ${option.ci} ${
                  blackListed ? ' - En lista negra' : ''
                }`
              }
              if (option.firstName) {
                return `${option.firstName} ${option.lastName} ${
                  blackListed ? ' - En lista negra' : ''
                }`
              }
              return ''
            },
            renderOption: (option) => {
              const blackListed = !!option.blackListed
              const textStyle = blackListed
                ? { color: 'red' }
                : { color: 'white' }

              if (option.firstName && option.ci) {
                return (
                  <span style={textStyle}>
                    {`${option.firstName} ${option.lastName} CI: ${option.ci} ${
                      blackListed ? ' - En lista negra' : ''
                    }`}
                  </span>
                )
              }
              if (option.firstName) {
                return (
                  <span style={textStyle}>
                    {`${option.firstName} ${option.lastName} ${
                      blackListed ? ' - En lista negra' : ''
                    }`}
                  </span>
                )
              }
              return null
            },
            infoBellowTitle: 'ACCESO OBRA',
            infoBellowContent:
              values.invitation?.constructions
                .map((construction) => construction?.construction?.name)
                .join(', ') || '',
          },
          {
            type: FieldTypes.TextField,
            label: 'Nombre',
            hint: 'Ingrese nombre',
            value: values.invitation
              ? values.invitation.firstName
              : values?.firstName,
            key: 'firstName',
            errorMessage: 'El nombre es requerido',
            disabled: !!values.invitation,
            onlyLetters: true,
            capitalized: true,
          },
          {
            type: FieldTypes.TextField,
            label: 'Apellido',
            hint: 'Ingrese apellido',
            value: values.invitation
              ? values.invitation.lastName
              : values?.lastName,
            key: 'lastName',
            errorMessage: 'El apellido es requerido',
            disabled: !!values.invitation,
            onlyLetters: true,
            capitalized: true,
          },
          {
            type: FieldTypes.TextField,
            label: 'Documento de identidad',
            hint: 'Ingrese un documento de identidad',
            key: 'ci',
            disabled: !!values.invitation,
            errorMessage: isCiBlacklisted
              ? 'La cédula de identidad está en la lista negra'
              : 'La cédula de identidad es requerida',
            forceShowErrorMessage: isCiBlacklisted,
            infoBellowTitle: 'ACCESO OBRA',
            infoBellowContent: getConstructionNameFromCI(values.ci),
          },
          {
            type: FieldTypes.TextField,
            label: 'Descripcion',
            hint: 'Ingrese una descripcion',
            key: 'description',
          },
          {
            type: FieldTypes.TextField,
            label: 'Matrícula',
            hint: 'Ingrese una matrícula',
            key: 'plate',
            allCaps: true,
          },
          {
            type: FieldTypes.UploadImage,
            label: 'Subir Imagen',
            key: 'selfie',
            onChange: (event) => handleSelectFile(event),
            selectedFile: values.selfie,
            inputRef: inputRef,
            withMargin: true,
            errorMessage: !values.invitation && 'Subir una foto es requerido',
          },
          {
            type: FieldTypes.Checkbox,
            checked: isService,
            onChange: () => setIsService(!isService),
            label: 'Servicio',
            withMargin: true,
          },
          ...(isService
            ? [
                {
                  type: FieldTypes.Select,
                  id: 'service-type',
                  label: 'Tipo de servicio',
                  hint: 'Seleccione un tipo de servicio',
                  key: 'vertical',
                  errorMessage: 'El tipo de servicio es requerido',
                  withMargin: true,
                  renderValue: (selected) => {
                    if (!selected) {
                      return (
                        <span
                          className={clsx(
                            classes.inputFont,
                            classes.selectPlaceholder
                          )}
                        >
                          Seleccione un tipo de servicio
                        </span>
                      )
                    }
                    const selectedOption =
                      userInvitationState?.serviceTypes.find(
                        (option) =>
                          option.id === selected ||
                          option.name.replaceAll('_', ' ') === selected ||
                          option.name === selected
                      )
                    return selectedOption.displayName
                  },
                  options: userInvitationState?.serviceTypes
                    ? userInvitationState?.serviceTypes?.map((type) => ({
                        value: type.id,
                        label: type.displayName,
                      }))
                    : [],
                },
              ]
            : []),
          ...(isService
            ? [
                {
                  type: FieldTypes.TextField,
                  label: 'Empresa',
                  hint: 'Ingrese el nombre de la empresa',
                  key: 'company',
                  errorMessage: 'La empresa es requerida',
                  withMargin: true,
                },
              ]
            : []),
          {
            type: FieldTypes.DoubleCheckbox,
            withMargin: true,
            checkboxes: [
              {
                checked: invitationType === 0,
                onChange: () => setInvitationType(0),
                label: 'Entrada',
              },
              {
                checked: invitationType === 1,
                onChange: () => setInvitationType(1),
                label: 'Salida',
              },
            ],
          },
          {
            type: FieldTypes.Autocomplete,
            label: 'Unidad asociada',
            hint: 'Seleccione al menos una unidad',
            key: 'apartments',
            errorMessage: 'Debe seleccionar al menos una unidad',
            options: building
              ? [
                  {
                    id: building.id,
                    name: building.name,
                    isGeneralService: true,
                  },
                  ...(getApartmentsFromBuildingState?.apartments || []),
                ]
              : getApartmentsFromBuildingState?.apartments || [],
            multiple: true,
            freeSolo: false,
            withMargin: true,
            disabled: !selectedBuilding,
            onChange: (value) => {
              setValues({ ...values, apartments: value })
            },
          },
          {
            type: FieldTypes.Autocomplete,
            label: 'Evento asociado',
            hint: 'Seleccione un evento',
            key: 'event',
            options:
              eventsState?.events
                .filter((evento) => new Date(evento.endTime) > new Date())
                .map((eventObj) => ({
                  ...eventObj,
                  apartment: eventObj?.user?.apartments[0]?.name,
                }))
                .sort((a, b) => -b.apartment.localeCompare(a.apartment)) || [],
            multiple: false,
            freeSolo: false,
            withMargin: true,
            onChange: (value) => {
              setValues({ ...values, event: value })
            },
            groupBy: (option) => option?.apartment,
          },
          {
            type: FieldTypes.Companions,
            companions: companions,
            invitations: userInvitationState?.invitations?.data,
            handleUpdateCompanions: (companion, i) =>
              handleUpdateCompanions(companion, i),
            handleRemoveCompanion: (i) => handleRemoveCompanion(i),
            handleAddCompanion: () => handleAddCompanion(),
            debouncedHandleInputChange: debouncedHandleInputChangeCampanion,
            loading: userInvitationState.isLoading,
          },
        ]}
        handleSubmit={() => handleSubmit()}
        handleCancel={handleCancel}
      />
    </div>
  )
}
